import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/energie-eolienne.png'

function WindTurbineNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Wind Turbine Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Wind Turbine</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default WindTurbineNode
